import AC1 from '../../Images/Daikin_Images/icon/AC1.png';
import AC2 from '../../Images/Daikin_Images/icon/AC2.png';
import AC3 from '../../Images/Daikin_Images/icon/AC3.png';
import AC4 from '../../Images/Daikin_Images/icon/AC4.png';
import AC5 from '../../Images/Daikin_Images/icon/AC5.png';
import AC6 from '../../Images/Daikin_Images/icon/AC6.png';
import AC7 from '../../Images/Daikin_Images/icon/AC7.png';
import AC8 from '../../Images/Daikin_Images/icon/AC8.png';
import AHU from '../../Images/Daikin_Images/icon/AHU.png';
import Air_Purifier from '../../Images/Daikin_Images/icon/AirPurifier.png';
import Alert from '../../Images/Daikin_Images/icon/Alert.png';
import Curtain from '../../Images/Daikin_Images/icon/Curtain.png';
import Door from '../../Images/Daikin_Images/icon/Door.png';
import Fan1 from '../../Images/Daikin_Images/icon/Fan1.png';
import Fan2 from '../../Images/Daikin_Images/icon/Fan2.png';
import Hrv from '../../Images/Daikin_Images/icon/Hrv.png';
import Humidity from '../../Images/Daikin_Images/icon/Humid.png';
import Keycard from '../../Images/Daikin_Images/icon/Keycard.png';
import Level1 from '../../Images/Daikin_Images/icon/Level1.png';
import Level2 from '../../Images/Daikin_Images/icon/Level2.png';
import Level3 from '../../Images/Daikin_Images/icon/Level3.png';
import Light1 from '../../Images/Daikin_Images/icon/Light1.png';
import Light2 from '../../Images/Daikin_Images/icon/Light2.png';
import Light3 from '../../Images/Daikin_Images/icon/Light3.png';
import Light4 from '../../Images/Daikin_Images/icon/Light4.png';
import Lock1 from '../../Images/Daikin_Images/icon/Lock1.png';
import Lock2 from '../../Images/Daikin_Images/icon/Lock2.png';
import PM2_5 from '../../Images/Daikin_Images/icon/PM2.5.png';
import Pump from '../../Images/Daikin_Images/icon/Pump.png';
import Roller_Shutter from '../../Images/Daikin_Images/icon/RollerShutter.png';
import Screen from '../../Images/Daikin_Images/icon/screen.png';
import Status1 from '../../Images/Daikin_Images/icon/Status1.png';
import Status2 from '../../Images/Daikin_Images/icon/Status2.png';
import Switch2 from '../../Images/Daikin_Images/icon/Switch2.png';
import Switch1 from '../../Images/Daikin_Images/icon/Switch1.png';
import Temp from '../../Images/Daikin_Images/icon/Temp.png';
import Window2 from '../../Images/Daikin_Images/icon/Window2.png';
import Window1 from '../../Images/Daikin_Images/icon/Window1.png';
import Meter from '../../Images/Daikin_Images/icon/Meter.png';
import Multi_Stat from '../../Images/Daikin_Images/icon/Multistat.png';

import fanStep2_1 from '../../Images/Cell_Status_Icon/Fanstep/fanstep2-L.png';
import fanStep2_5 from '../../Images/Cell_Status_Icon/Fanstep/fanstep2-H.png';
import fanStep2_auto from '../../Images/Cell_Status_Icon/Fanstep/fanstep2-A.png';
import fanStep2_quiet from '../../Images/Cell_Status_Icon/Fanstep/fanstep2-Q.png';
import fanStep3_1 from '../../Images/Cell_Status_Icon/Fanstep/fanstep3-L.png';
import fanStep3_3 from '../../Images/Cell_Status_Icon/Fanstep/fanstep3-M.png';
import fanStep3_5 from '../../Images/Cell_Status_Icon/Fanstep/fanstep3-H.png';
import fanStep3_auto from '../../Images/Cell_Status_Icon/Fanstep/fanstep3-A.png';
import fanStep3_quiet from '../../Images/Cell_Status_Icon/Fanstep/fanstep3-Q.png';
import fanStep5_1 from '../../Images/Cell_Status_Icon/Fanstep/fanstep5-L.png';
import fanStep5_2 from '../../Images/Cell_Status_Icon/Fanstep/fanstep5-LM.png';
import fanStep5_3 from '../../Images/Cell_Status_Icon/Fanstep/fanstep5-M.png';
import fanStep5_4 from '../../Images/Cell_Status_Icon/Fanstep/fanstep5-MH.png';
import fanStep5_5 from '../../Images/Cell_Status_Icon/Fanstep/fanstep5-H.png';
import fanStep5_auto from '../../Images/Cell_Status_Icon/Fanstep/fanstep5-A.png';
import fanStep5_quiet from '../../Images/Cell_Status_Icon/Fanstep/fanstep5-Q.png';

import flap from '../../Images/Cell_Status_Icon/Flap/flap.png';
import flap0 from '../../Images/Cell_Status_Icon/Flap/flap0.png';
import flap1 from '../../Images/Cell_Status_Icon/Flap/flap1.png';
import flap2 from '../../Images/Cell_Status_Icon/Flap/flap2.png';
import flap3 from '../../Images/Cell_Status_Icon/Flap/flap3.png';
import flap4 from '../../Images/Cell_Status_Icon/Flap/flap4.png';
import flapS from '../../Images/Cell_Status_Icon/Flap/flapS.png';
import flapN from '../../Images/Cell_Status_Icon/Flap/flapN.png';
import flapA from '../../Images/Cell_Status_Icon/Flap/flapA.png';

import hflap from '../../Images/Cell_Status_Icon/Flap2/hflap.png';
import hflap0 from '../../Images/Cell_Status_Icon/Flap2/hflap0.png';
import hflap1 from '../../Images/Cell_Status_Icon/Flap2/hflap1.png';
import hflap2 from '../../Images/Cell_Status_Icon/Flap2/hflap2.png';
import hflap3 from '../../Images/Cell_Status_Icon/Flap2/hflap3.png';
import hflap4 from '../../Images/Cell_Status_Icon/Flap2/hflap4.png';
import hflapS from '../../Images/Cell_Status_Icon/Flap2/hflapS.png';
import hflapN from '../../Images/Cell_Status_Icon/Flap2/hflapN.png';
import hflapA from '../../Images/Cell_Status_Icon/Flap2/hflapA.png';

//AC Mode Icon
import Cool from '../../Images/Daikin_Images/image/Cool.png';
import Heat from '../../Images/Daikin_Images/image/Heat.png';
import Fan from '../../Images/Daikin_Images/image/Fan.png';
import Dry from '../../Images/Daikin_Images/image/Dry.png';
import Auto from '../../Images/Daikin_Images/image/Auto.png';
import TempControl from '../../Images/Daikin_Images/image/TempControl.png';

//AC 3Pipe Mode2 Icon
import Mode2AD from '../../Images/Daikin_Images/image/AD.png';
import Mode2BD from '../../Images/Daikin_Images/image/BD.png';
import Mode2GS from '../../Images/Daikin_Images/image/GS.png';
import Mode2PH from '../../Images/Daikin_Images/image/PH.png';
import Mode2RD from '../../Images/Daikin_Images/image/RD.png';
import Mode2NON from '../../Images/Daikin_Images/image/NON.png';

//AC 3Pipe BVent Icon
import BVentS from '../../Images/Daikin_Images/image/bvent_Stop.png';
import BVentL from '../../Images/Daikin_Images/image/bvent_L.png';
import BVentH from '../../Images/Daikin_Images/image/bvent_H.png';

//AC 3Pipe Humidity Icon
import HumL from '../../Images/Daikin_Images/image/hum_L.png';
import HumM from '../../Images/Daikin_Images/image/hum_M.png';
import HumH from '../../Images/Daikin_Images/image/hum_H.png';

import FireAlarm from '../../Images/Daikin_Images/icon/FireAlarm.png';
import FloodSensor from '../../Images/Daikin_Images/icon/FloodSensor.png';
import SmokeDetector from '../../Images/Daikin_Images/icon/SmokeDetector.png';
import MotionSensor from '../../Images/Daikin_Images/icon/MotionSensor.png';
import Illuminance from '../../Images/Daikin_Images/icon/Illuminance.png';
import TV from '../../Images/Daikin_Images/icon/TV.png';

// Scene Icons
import Backhome from '../../Images/Daikin_Images/icon/Scene/Backhome.png';
import Leave from '../../Images/Daikin_Images/icon/Scene/Leave.png';
import Lunch from '../../Images/Daikin_Images/icon/Scene/Lunch.png';
import Night from '../../Images/Daikin_Images/icon/Scene/Night.png';
import Officetime from '../../Images/Daikin_Images/icon/Scene/Officetime.png';
import OpenOffice from '../../Images/Daikin_Images/icon/Scene/OpenOffice.png';
import Sleep from '../../Images/Daikin_Images/icon/Scene/Sleep.png';
import Wakeup from '../../Images/Daikin_Images/icon/Scene/Wakeup.png';

// Groups Icons
import Building from '../../Images/Daikin_Images/icon/Groups/Building.png';
import Floor from '../../Images/Daikin_Images/icon/Groups/Floor.png';
import House from '../../Images/Daikin_Images/icon/Groups/House.png';
import Office from '../../Images/Daikin_Images/icon/Groups/Office.png';
import Room from '../../Images/Daikin_Images/icon/Groups/Room.png';

// VAM icons
import Vm_Auto from '../../Images/Daikin_Images/image/vm-auto.png';
import Vm_Bypass from '../../Images/Daikin_Images/image/vm-bypas.png';
import Vm_Heatex from '../../Images/Daikin_Images/image/vm-heatex.png';

// Hotel guest room icons
import Single from '../../Images/Daikin_Images/icon/Hotel/Single.png';
import Twin from '../../Images/Daikin_Images/icon/Hotel/Twin.png';
import Double from '../../Images/Daikin_Images/icon/Hotel/Double.png';
import Suite from '../../Images/Daikin_Images/icon/Hotel/Suite.png';
import Resort from '../../Images/Daikin_Images/icon/Hotel/Resort.png';

// for hash functions
import { sha256 } from 'js-sha256';

export function getIcon(iconName, stat) {
	let icon = null;

	switch (iconName) {
		case 'AC1.png':
			icon = AC1;
			break;
		case 'AC2.png':
			icon = AC2;
			break;
		case 'AC3.png':
			icon = AC3;
			break;
		case 'AC4.png':
			icon = AC4;
			break;
		case 'AC5.png':
			icon = AC5;
			break;
		case 'AC6.png':
			icon = AC6;
			break;
		case 'AC7.png':
			icon = AC7;
			break;
		case 'AC8.png':
			icon = AC8;
			break;
		case 'AHU.png':
			icon = AHU;
			break;
		case 'AirPurifier.png':
			icon = Air_Purifier;
			break;
		case 'Alert.png':
			icon = Alert;
			break;
		case 'Curtain.png':
			icon = Curtain;
			break;
		case 'Door.png':
			icon = Door;
			break;
		case 'Fan1.png':
			icon = Fan1;
			break;
		case 'Fan2.png':
			icon = Fan2;
			break;
		case 'Hrv.png':
			icon = Hrv;
			break;
		case 'Humid.png':
			icon = Humidity;
			break;
		case 'Keycard.png':
			icon = Keycard;
			break;
		case 'Level1.png':
			icon = Level1;
			break;
		case 'Level2.png':
			icon = Level2;
			break;
		case 'Level3.png':
			icon = Level3;
			break;
		case 'Light1.png':
			icon = Light1;
			break;
		case 'Light2.png':
			icon = Light2;
			break;
		case 'Light3.png':
			icon = Light3;
			break;
		case 'Light4.png':
			icon = Light4;
			break;
		case 'Lock1.png':
			icon = Lock1;
			break;
		case 'Lock2.png':
			icon = Lock2;
			break;
		case 'PM2.5.png':
			icon = PM2_5;
			break;
		case 'Pump.png':
			icon = Pump;
			break;
		case 'RollerShutter.png':
			icon = Roller_Shutter;
			break;
		case 'Screen.png':
			icon = Screen;
			break;
		case 'Status1.png':
			icon = Status1;
			break;
		case 'Status2.png':
			icon = Status2;
			break;
		case 'Switch2.png':
			icon = Switch2;
			break;
		case 'Switch1.png':
			icon = Switch1;
			break;
		case 'Temp.png':
			icon = Temp;
			break;
		case 'Window2.png':
			icon = Window2;
			break;
		case 'Window1.png':
			icon = Window1;
			break;
		case 'Meter.png':
			icon = Meter;
			break;
		case 'Multistat.png':
			icon = Multi_Stat;
			break;
		case 'FireAlarm.png':
			icon = FireAlarm;
			break;
		case 'FloodSensor.png':
			icon = FloodSensor;
			break;
		case 'Illuminance.png':
			icon = Illuminance;
			break;
		case 'MotionSensor.png':
			icon = MotionSensor;
			break;
		case 'SmokeDetector.png':
			icon = SmokeDetector;
			break;
		case 'TV.png':
			icon = TV;
			break;
		// Groups Icons
		case 'Building.png':
			icon = Building;
			break;
		case 'Floor.png':
			icon = Floor;
			break;
		case 'House.png':
			icon = House;
			break;
		case 'Office.png':
			icon = Office;
			break;
		case 'Room.png':
			icon = Room;
			break;
		default:
			icon = Alert
			break;
	}

	return icon;
}

export function addAnimation(elem, animation_name, callback, timeout) {
	if (timeout == undefined || timeout == null) timeout = 300;
	elem.classList.add(animation_name);
	setTimeout(() => {
		if (elem != null) {
			elem.classList.remove(animation_name);
		}
		callback();
	}, timeout);
}

//for {} objects
export function isEmpty(obj) {
	if (obj == undefined || obj == null) {
		return true;
	}

	if (obj == true || obj == false) {
		return false;
	}
	for (let prop in obj) {
		if (obj.hasOwnProperty(prop))
			return false;
	}
	return true;
}

export function makeTimeString(num) {
	if (num < 10) {
		return ('0' + num.toString());
	} else {
		return (num.toString());
	}
}

/*
 * Cache to send commands only after 1 sec
 */

let comm_cache = {};
let comm_cache_group = {};
let send_command_timer = null;
let send_group_command_timer = null;

export function pushCommand(command, val, id) {
	comm_cache[command] = val;
	if (send_command_timer != null) clearTimeout(send_command_timer);
	send_command_timer = setTimeout(() => sendCommand(id), 1000);
}

export function sendCommand(id) {
	//{id:{item:stat,…},…}
	send_command_timer = null;
	let command = {};
	command[id] = comm_cache;
	window.app.receiver.operate(command)
	comm_cache = {};
}

export function pushGroupCommand(command, val, id) {
	comm_cache_group[command] = val;
	if (send_group_command_timer != null) clearTimeout(send_group_command_timer);
	send_group_command_timer = setTimeout(() => sendGroupCommand(id), 1000);
}

export function sendGroupCommand(id) {
	//{id:{item:stat,…},…}
	send_group_command_timer = null;
	let command = [];
	command.push(id);
	command.push(comm_cache_group);
	window.app.receiver.exec(command);
	comm_cache_group = {};
}

export function getFanstepIcon(steps, step) {
	if (steps == 2) {
		if (step == 'L') return fanStep2_1;
		else if (step == 'H') return fanStep2_5;
		else if (step == 'A') return fanStep2_auto;
		else if (step == 'Q') return fanStep2_quiet;
	} else if (steps == 3) {
		if (step == 'L') return fanStep3_1;
		else if (step == 'M') return fanStep3_3;
		else if (step == 'H') return fanStep3_5;
		else if (step == 'A') return fanStep3_auto;
		else if (step == 'Q') return fanStep3_quiet;
	} else if (steps == 5) {
		if (step == 'L') return fanStep5_1;
		else if (step == 'LM') return fanStep5_2;
		else if (step == 'M') return fanStep5_3;
		else if (step == 'MH') return fanStep5_4;
		else if (step == 'H') return fanStep5_5;
		else if (step == 'A') return fanStep5_auto;
		else if (step == 'Q') return fanStep5_quiet;
	}
	else return null;
}

export function getFlapIcon(steps, flapVar) {
	if (flapVar == 'S') return flapS;
	else if (flapVar == 'A') return flapA;
	else if (flapVar == 'N') return flapN;
	else if (steps == 0) return flapN;
	else if (flapVar == null) return flap;

	flapVar = parseInt(flapVar);

	switch (flapVar) {
		case 0:
			return flap0;
			break;
		case 1:
			return flap1;
			break;
		case 2:
			return flap2;
			break;
		case 3:
			return flap3;
			break;
		case 4:
			return flap4;
			break;
		case 7:
			return flapS;
			break;
		case 8:
			return flapN;
			break;
		default:
			return flap;
	}
}

export function getFlap2Icon(hsteps, flap2) {
	if (flap2 == 'S') return hflapS;
	else if (flap2 == 'A') return hflapA;
	else if (flap2 == 'N') return hflapN;
	else if (hsteps == 0) return hflapN;
	else if (flap2 == null) return hflap;

	flap2 = parseInt(flap2);

	switch (flap2) {
		case 0:
			return hflap0;
			break;
		case 1:
			return hflap1;
			break;
		case 2:
			return hflap2;
			break;
		case 3:
			return hflap3;
			break;
		case 4:
			return hflap4;
			break;
		/*case 5:
			return flap5;
			break;
		case 6:
			return flap6;
			break;*/
		case 7:
			return hflapS;
			break;
		case 8:
			return hflapN;
			break;
		default:
			return hflap;
	}
}

export function getModeIcon(mode) {
	let icon = null;

	if (mode == 'C') {
		icon = Cool;
	} else if (mode == 'H') {
		icon = Heat;
	} else if (mode == 'F') {
		icon = Fan;
	} else if (mode == 'D') {
		icon = Dry;
	} else if (mode == 'A') {
		icon = Auto;
	} else if (mode == 'T') {
		icon = TempControl;
	}

	return icon;
}

export function getMode2Icon(mode) {
	let icon = null;

	if (mode == 'RD') {
		icon = Mode2RD;
	} else if (mode == 'AD') {
		icon = Mode2AD;
	} else if (mode == 'GS') {
		icon = Mode2GS;
	} else if (mode == 'BD') {
		icon = Mode2BD;
	} else if (mode == 'PH') {
		icon = Mode2PH;
	} else if (mode == 'NON') {
		icon = Mode2NON;
	}

	return icon;
}

export function getVModeIcon(vmode) {
	let icon = null;

	if (vmode == 'HX') {
		icon = Vm_Heatex;
	} else if (vmode == 'S') {
		icon = Vm_Bypass;
	} else if (vmode == 'A') {
		icon = Vm_Auto;
	}

	return icon;
}

export function getBathVentIcon(bvent) {
	if (bvent == 'S') {
		return BVentS;
	} else if (bvent == 'L') {
		return BVentL;
	} else if (bvent == 'H') {
		return BVentH;
	}
	else return null;
}

export function getHumidityIcon(hum) {
	if (hum == 'L') {
		return HumL;
	} else if (hum == 'M') {
		return HumM;
	} else if (hum == 'H') {
		return HumH;
	}
	else return null;
}

export function getSceneIconList() {
	let list = [
		{
			key: 'Backhome.png',
			icon: Backhome,
			is_selected: false,
		},
		{
			key: 'Leave.png',
			icon: Leave,
			is_selected: false,
		},
		{
			key: 'Lunch.png',
			icon: Lunch,
			is_selected: false,
		},
		{
			key: 'Night.png',
			icon: Night,
			is_selected: false,
		},
		{
			key: 'Officetime.png',
			icon: Officetime,
			is_selected: false,
		},
		{
			key: 'OpenOffice.png',
			icon: OpenOffice,
			is_selected: false,
		},
		{
			key: 'Sleep.png',
			icon: Sleep,
			is_selected: false,
		},
		{
			key: 'Wakeup.png',
			icon: Wakeup,
			is_selected: false,
		},
	];

	return list;
}

export function getSceneIcon(iconName) {
	let icon = null;

	switch (iconName) {
		case 'Backhome.png':
			icon = Backhome;
			break;
		case 'Leave.png':
			icon = Leave;
			break;
		case 'Lunch.png':
			icon = Lunch;
			break;
		case 'Night.png':
			icon = Night;
			break;
		case 'Officetime.png':
			icon = Officetime;
			break;
		case 'OpenOffice.png':
			icon = OpenOffice;
			break;
		case 'Sleep.png':
			icon = Sleep;
			break;
		case 'Wakeup.png':
			icon = Wakeup;
			break;
		default:

	}

	return icon;
}

export function getPointIconList() {
	let list = [
		{
			key: 'AC1.png',
			icon: AC1,
			is_selected: false,
		},
		{
			key: 'AC2.png',
			icon: AC2,
			is_selected: false,
		},
		{
			key: 'AC3.png',
			icon: AC3,
			is_selected: false,
		},
		{
			key: 'AC4.png',
			icon: AC4,
			is_selected: false,
		},
		{
			key: 'AC5.png',
			icon: AC5,
			is_selected: false,
		},
		{
			key: 'AC6.png',
			icon: AC6,
			is_selected: false,
		},
		{
			key: 'AC7.png',
			icon: AC7,
			is_selected: false,
		},
		{
			key: 'AC8.png',
			icon: AC8,
			is_selected: false,
		},
		{
			key: 'AHU.png',
			icon: AHU,
			is_selected: false,
		},
		{
			key: 'AirPurifier.png',
			icon: Air_Purifier,
			is_selected: false,
		},
		{
			key: 'Alert.png',
			icon: Alert,
			is_selected: false,
		},
		{
			key: 'Curtain.png',
			icon: Curtain,
			is_selected: false,
		},
		{
			key: 'Door.png',
			icon: Door,
			is_selected: false,
		},
		{
			key: 'Fan1.png',
			icon: Fan1,
			is_selected: false,
		},
		{
			key: 'Fan2.png',
			icon: Fan2,
			is_selected: false,
		},
		{
			key: 'Hrv.png',
			icon: Hrv,
			is_selected: false,
		},
		{
			key: 'Humid.png',
			icon: Humidity,
			is_selected: false,
		},
		{
			key: 'Keycard.png',
			icon: Keycard,
			is_selected: false,
		},
		{
			key: 'Level1.png',
			icon: Level1,
			is_selected: false,
		},
		{
			key: 'Level2.png',
			icon: Level2,
			is_selected: false,
		},
		{
			key: 'Level3.png',
			icon: Level3,
			is_selected: false,
		},
		{
			key: 'Light1.png',
			icon: Light1,
			is_selected: false,
		},
		{
			key: 'Light2.png',
			icon: Light2,
			is_selected: false,
		},
		{
			key: 'Light3.png',
			icon: Light3,
			is_selected: false,
		},
		{
			key: 'Light4.png',
			icon: Light4,
			is_selected: false,
		},
		{
			key: 'Lock1.png',
			icon: Lock1,
			is_selected: false,
		},
		{
			key: 'Lock2.png',
			icon: Lock2,
			is_selected: false,
		},
		{
			key: 'PM2.5.png',
			icon: PM2_5,
			is_selected: false,
		},
		{
			key: 'Pump.png',
			icon: Pump,
			is_selected: false,
		},
		{
			key: 'RollerShutter.png',
			icon: Roller_Shutter,
			is_selected: false,
		},
		{
			key: 'Screen.png',
			icon: Screen,
			is_selected: false,
		},
		{
			key: 'Status1.png',
			icon: Status1,
			is_selected: false,
		},
		{
			key: 'Status2.png',
			icon: Status2,
			is_selected: false,
		},
		{
			key: 'Switch1.png',
			icon: Switch1,
			is_selected: false,
		},
		{
			key: 'Switch2.png',
			icon: Switch2,
			is_selected: false,
		},
		{
			key: 'Temp.png',
			icon: Temp,
			is_selected: false,
		},
		{
			key: 'Window1.png',
			icon: Window1,
			is_selected: false,
		},
		{
			key: 'Window2.png',
			icon: Window2,
			is_selected: false,
		},
		{
			key: 'Meter.png',
			icon: Meter,
			is_selected: false,
		},
		{
			key: 'Multistat.png',
			icon: Multi_Stat,
			is_selected: false,
		},
		{
			key: 'FireAlarm.png',
			icon: FireAlarm,
			is_selected: false,
		},
		{
			key: 'FloodSensor.png',
			icon: FloodSensor,
			is_selected: false,
		},
		{
			key: 'MotionSensor.png',
			icon: MotionSensor,
			is_selected: false,
		},
		{
			key: 'Illuminance.png',
			icon: Illuminance,
			is_selected: false,
		},
		{
			key: 'SmokeDetector.png',
			icon: SmokeDetector,
			is_selected: false,
		},
		{
			key: 'TV.png',
			icon: TV,
			is_selected: false,
		},

	];

	return list;
}

export function getGroupIconList() {
	let point_icon_list = getPointIconList();

	let list = [
		{
			key: 'Building.png',
			icon: Building,
			is_selected: false,
		},
		{
			key: 'Floor.png',
			icon: Floor,
			is_selected: false,
		},
		{
			key: 'House.png',
			icon: House,
			is_selected: false,
		},
		{
			key: 'Office.png',
			icon: Office,
			is_selected: false,
		},
		{
			key: 'Room.png',
			icon: Room,
			is_selected: false,
		}
	];

	// Combine with point_icon_list
	list = [...list, ...point_icon_list];

	return list;
}

export function getGuestRoomIcon(icon_name) {
	let icon = null;

	switch (icon_name) {
		case 'Single.png':
			icon = Single;
			break;
		case 'Twin.png':
			icon = Twin;
			break;
		case 'Double.png':
			icon = Double;
			break;
		case 'Suite.png':
			icon = Suite;
			break;
		case 'Resort.png':
			icon = Resort;
			break;
		default:
			icon = Single;
	}
	return icon;
}


export function getGuestRoomIconList() {
	let list = [
		{
			key: 'Single.png',
			icon: Single,
			is_selected: false,
		},
		{
			key: 'Twin.png',
			icon: Twin,
			is_selected: false,
		},
		{
			key: 'Double.png',
			icon: Double,
			is_selected: false,
		},
		{
			key: 'Suite.png',
			icon: Suite,
			is_selected: false,
		},
		{
			key: 'Resort.png',
			icon: Resort,
			is_selected: false,
		},
	];

	return list;
}

//Special Calendar functions
//get the week of the month
export function getWeek(temp_date) {
	if (temp_date.getDate() == 1) return 1;
	let week = Math.floor((temp_date.getDate() - 1) / 7 + 1);

	if (week == 5) week = 'last';

	// Next Version
	/*let this_month = temp_date.getMonth();
	let next_week = new Date(temp_date.getFullYear(), temp_date.getMonth(), temp_date.getDate()+7);
	if(this_month !== next_week.getMonth()){
		//return 'last';
	}*/

	return week;
}

//get the date by using day by week
//day by week is stored as : {month:[{"type":"day","day":day,"week":week},..]} 
//in order to get the date to display in calendar, we need a function to convert this data into a date
export function getDateFromDayByWeek(day, week, month, new_date) {
	new_date.setHours(0, 0, 0);
	new_date.setMilliseconds(0);
	new_date.setMonth(parseInt(month));

	// for Specified by Week
	//let days = ['sun','mon','tue','wed','thu','fri','sat'];
	if (week == 'last') {
		new_date.setMonth(parseInt(month) + 1, 0);
		let count = 0
		while (count < 7) {
			if (new_date.getDay() == day) {
				return new Date(new_date);
			}
			new_date.setDate(new_date.getDate() - 1);
			count++;
		}
	} else {
		week = parseInt(week);
		new_date.setDate(1);
		if (week == 1) {
			let count = 0;
			while (count < 7) {
				if (new_date.getDay() == day) {
					return new Date(new_date);
				}
				new_date.setDate(new_date.getDate() + 1);
				count++;
			}
		} else {
			let numDays = (week - 1) * 7 + 1;
			new_date.setDate(numDays);
			let count = 0;
			while (count < 7) {
				if (new_date.getDay() == day) {
					return new Date(new_date);
				}
				new_date.setDate(new_date.getDate() + 1);
				count++;
			}
		}
	}
}

export function getPointName(point_id) {
	// Checks and returns point name. Returns point_id if point_id doesnt exist in current point_list
	let point_name = point_id;

	let point_info = window.app.state.point_list[point_id];
	if (!isEmpty(point_info)) {
		point_name = point_info.name;
	}

	return point_name;
}
/*
export function getFlap2Icon(steps, flap) {
	if(flap == 'swing') return wvflapS;
	else if(steps == 0)	return wvflapN;
}*/

export function getMonthName(month_num) {
	const monthNames = [
		window.app.receiver.getString('mon0'),
		window.app.receiver.getString('mon1'),
		window.app.receiver.getString('mon2'),
		window.app.receiver.getString('mon3'),
		window.app.receiver.getString('mon4'),
		window.app.receiver.getString('mon5'),
		window.app.receiver.getString('mon6'),
		window.app.receiver.getString('mon7'),
		window.app.receiver.getString('mon8'),
		window.app.receiver.getString('mon9'),
		window.app.receiver.getString('mon10'),
		window.app.receiver.getString('mon11'),
	];

	return monthNames[month_num];
}

export function getWeekName(week_num) {
	if (week_num == 'last') return window.app.receiver.getString('week6');

	const week_names = [
		window.app.receiver.getString('week1'),
		window.app.receiver.getString('week2'),
		window.app.receiver.getString('week3'),
		window.app.receiver.getString('week4'),
		window.app.receiver.getString('week5'),
		window.app.receiver.getString('week6'),
	];

	return week_names[week_num - 1];
}

export function getDayName(day_num) {
	const day_names = [
		window.app.receiver.getString('sunday'),
		window.app.receiver.getString('monday'),
		window.app.receiver.getString('tuesday'),
		window.app.receiver.getString('wednesday'),
		window.app.receiver.getString('thursday'),
		window.app.receiver.getString('friday'),
		window.app.receiver.getString('saturday'),
	];

	return day_names[day_num];
}

export const df_options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };

export function getLocale(lang) {
	switch (lang) {
		case 'EN':
			return 'en-GB';
		case 'JP':
			return 'ja-JP';
		case 'CH':
			return 'zh-CN';
		case 'TW':
			return 'zh-TW';
		case 'HK':
			return 'zh-HK';
		case 'BR':
			return 'pt-BR';
		case 'ES':
			return 'es-ES';
		case 'VN':
			return 'vi-VN';
		case 'THAI':
			return 'th-TH';
		case 'BAH':
			return 'id-ID';
		default:
			return 'en-GB';
	}
}

export function validateFloat(value) {
	// Changed to ===. Cannot use == because we wont know what data type is passed in.
	if (value === '' || value == undefined || value == null) return false;
	value = value.toString();
	return !isNaN(value.trim());
}

export function trimFloat(value) {
	value = parseFloat(value);
	return value;
}

/*
 * Check Energy/Water/Gas Management point types 
 */

export function isEnergyDevice(point_info) {
	if (isEmpty(point_info)) {
		return false;
	}
	if ((point_info.type == 'Meter' || point_info.type == 'SMeter') && (point_info.usage == 'emeter')) {
		return true;
	}
	return false;
}

export function isWaterDevice(point_info) {
	if (isEmpty(point_info)) {
		return false;
	}
	if ((point_info.type == 'Meter' || point_info.type == 'SMeter') && (point_info.usage == 'wmeter')) {
		return true;
	}
	return false;
}

export function isGasDevice(point_info) {
	if (isEmpty(point_info)) {
		return false;
	}
	if ((point_info.type == 'Meter' || point_info.type == 'SMeter') && (point_info.usage == 'gmeter')) {
		return true;
	}
	return true;
}

// Download csv
export function handleDownloadCSV(csv, file_name) {
	var csvFile;
	var downloadLink;

	// CSV FILE
	csvFile = new Blob([csv], { type: "text/csv" });

	// Download link
	downloadLink = document.createElement("a");

	// File name
	downloadLink.download = file_name;

	// We have to create a link to the file
	downloadLink.href = window.URL.createObjectURL(csvFile);

	// Make sure that the link is not displayed
	downloadLink.style.display = "none";

	// Add the link to your DOM
	document.body.appendChild(downloadLink);

	// Lanzamos
	downloadLink.click();
}

/*
 * For Checking whether or not to display the following functionalities
 */

export function getIsShowSetpoint(point_info, auth) {
	if (point_info.sp_cap && !auth.sp_proh) return true;
	return false;
}

export function getIsShowSetpointRange(available_functions) {
	if (available_functions.sp_range) return true;
	return false;
}

export function getIsShowHumSetpoint(point_info) {
	if (point_info.hasOwnProperty('type')){
		if(point_info.type == 'Dehumi' ) return true;
	}
	return false;
}

export function getIsShowMode(point_info, auth) {
	if (point_info.mode_cap != null && !auth.mode_proh) return true;
	return false;
}

export function getIsShowFanstep(point_info) {
	if (point_info.fanstep_cap != null) {
		if (point_info.fanstep_cap.S != null && point_info.fanstep_cap.S != 0) {
			return true
		}
	}
	return false;
}

export function getIsShowFlap(point_info) {
	if (point_info.flap_cap != null) {
		if (point_info.flap_cap.D != 0) {
			return true;
		}
	}
	return false;
}

export function getIsShowVMode(point_info) {
	if (point_info.vmode_cap != null) {
		if (point_info.vmode_cap.A || point_info.vmode_cap.HX || point_info.vmode_cap.S) {
			return true;
		}
		//return point_info.vmode_cap;
	}
	return false;
}

export function getIsShowVAmount(point_info) {
	if (point_info.vamount_cap != null) {
		if (point_info.vamount_cap.A || point_info.vamount_cap.H || point_info.vamount_cap.L) {
			return true;
		}
		//return point_info.vamount_cap;
	}
	return false;
}

export function getIsShowRcProhOp(point_info, available_functions) {
	if (point_info.rc_proh_cap && available_functions.rc_proh) return true;
	return false;
}

export function getIsShowRcProhMode(point_info, available_functions) {
	if (point_info.rc_proh_cap && available_functions.rc_proh) return true;
	return false;
}

export function getIsShowRcProhSP(point_info, available_functions) {
	if (point_info.rc_proh_cap && available_functions.rc_proh) return true;
	return false;
}

export function getIsShowRcProhFanstep(point_info, available_functions) {
	if (point_info.rc_proh_cap && available_functions.rc_proh) return true;
	return false;
}

export function getIsShowSB(available_functions) {
	if (available_functions.setback) return true;
	return false;
}

export function getIsShowMode2(point_info) {
	if (point_info.mode2_cap != null) {
		if (point_info.mode2_cap.RD || point_info.mode2_cap.AD
			|| point_info.mode2_cap.GS || point_info.mode2_cap.BD
			|| point_info.mode2_cap.PH) {
			return true;
		}
	}
	return false;
}

export function getIsShowFlap2(point_info) {
	if (point_info.flap2_cap != null) {
		if (point_info.flap2_cap.S != null && point_info.flap2_cap.S != 0) {
			return true;
		}
	}
	return false;
}

export function getIsShowPowerfulMode(point_info) {
	if (point_info.opt_cap != null) {
		if (point_info.opt_cap.P != null && point_info.opt_cap.P != 0) {
			return true;
		}
	}
	return false;
}

export function getIsShowEcoMode(point_info) {
	if (point_info.opt_cap != null) {
		if (point_info.opt_cap.E != null && point_info.opt_cap.E != 0) {
			return true;
		}
	}
	return false;
}

export function getIsShowStreamerMode(point_info) {
	if (point_info.opt_cap != null) {
		if (point_info.opt_cap.S != null && point_info.opt_cap.S != 0) {
			return true;
		}
	}
	return false;
}

export function getIsShowBVent(point_info) {
	if (point_info.bvent_cap != null) {
		return point_info.bvent_cap;
	}
	return false;
}

export function getIsShowHum(point_info) {
	if (point_info.hum_cap != null) {
		return point_info.hum_cap;
	}
	return false;
}

export function getIsShowForceOff(point_info) {
	if (point_info.foff_op_cap) {
		if (point_info.foff == 'on') return true;
	}
	return false;
}

export function getIsShowForceOffThermo(point_info) {
	if (point_info.fthoff_op_cap) {
		if (point_info.fthoff == 'on') return true;
	}
	return false;
}

// Create Hash for security
export function getHash(val) {
	return sha256(val);
}